<template>
  <div class="experience-wrapper--tabs">
    <LadAdvancedTabs
      :base="base"
      :tabs="tabs"
      :with-sticky="true"
      :with-auto-scroll="false"
      :sticky-options="{ relative: '.experience-wrapper--tabs', top: 60 }"
      :tabs-id="`experienceIndexTab`"
      :default-step="currentStep"
      @tab-click="handleClick"
      @current-tab="updateCurrentTab"
    >
      <LadTabWhatsIncluded v-if="tabs.includes('whats-included')" />

      <LadMessageLocalFlex v-if="isPpcv1" />

      <LadTabOverview v-if="tabs.includes('overview')" />
    </LadAdvancedTabs>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import CacheComponentMixin from '@/utils/mixin/cache-components'

export default {
  name: 'LadExperienceTabs',
  components: {
    LadMessageLocalFlex: () =>
      import(
        /* webpackChunkName: "lad-message-local-flex" */ '@/components/pages/experience/partials/message-localflex'
      ),
    LadAdvancedTabs: () =>
      import(
        /* webpackChunkName: "lad-advanced-tabs" */ '@/components/advanced-tabs'
      ),
    LadTabOverview: () =>
      import(
        /* webpackChunkName: "lad-tab-overview" */ './components/overview'
      ),
    LadTabWhatsIncluded: () =>
      import(
        /* webpackChunkName: "lad-tab-whats-included" */ './components/whats-included'
      ),
  },
  mixins: [CacheComponentMixin],
  data() {
    return {
      base: 'experience.tabs',
      currentStep: 'whats-included',
    }
  },
  computed: {
    ...mapGetters('device', ['isMobile']),
    ...mapState('experience', {
      isLad: (state) => state.experience.is_lad,
      uuid: (state) => state.experience.uuid,
      tabs: (state) => {
        /** revisar `components/pages/experience-package/index.vue` si hay cambios aqui */
        const tabs = []
        const items = [].concat(
          state.extras.map((t) => t.uuid),
          state.rooms.map((t) => t.uuid),
          state.insurances.map((t) => t.uuid),
          state.flights.map((t) => t.uuid)
        )

        if (state.whats_included.length) tabs.push('whats-included')

        tabs.push('overview')

        if (items.length > 0) tabs.push('extras')
        if (state.for_me.length) tabs.push('for-me')
        if (state.faqs.length) tabs.push('faqs')

        return tabs
      },
    }),
    isPpcv1() {
      return this.$route.params.test === 'ppcv1' && this.isLad
    },
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        if (this.tabs.includes(route.params.section)) {
          switch (route.params.section) {
            case 'whats-included':
            case 'for-me':
            case 'faqs':
            case 'extras':
              this.currentStep = route.params.section
              break
            default:
              this.currentStep = 'whats-included'
              break
          }
        } else {
          this.currentStep = 'whats-included'
        }
      },
    },
    uuid(value) {
      if (value && typeof this.$route.params.tab !== 'undefined') {
        this.LadNextTick(
          () => this.$scrollTo('#experience-wrapper--main-top'),
          'LadExperienceTabs'
        )
      }
    },
  },
  methods: {
    handleClick(tab, event) {
      // this.$scrollTo('#experience-wrapper--main-top')
      // this.$scrollTo('#checkout-wrapper--main-top', 400, { offset: -120 })
    },
    updateCurrentTab(tab) {
      this.currentStep = tab
      switch (tab) {
        case 'overview':
          this.$scrollTo('.experience-wrapper--tab-overview', { offset: 70 })
          break
        case 'whats-included':
          this.$scrollTo('.section-whats_included', { offset: -150 })
          break
        case 'for-me':
          this.$scrollTo('.section-is_for_me', { offset: -150 })
          break
        case 'faqs':
          this.$scrollTo('.experience-wrapper--tab-faqs', { offset: -70 })
          break
        case 'extras':
          this.$scrollTo('.section-extras', {
            offset: this.isMobile ? -170 : -20,
          })
          break
        default:
          break
      }
    },
  },
}
</script>
